<template>
  <v-card class="fill-height text-left d-flex flex-column dsfr" outlined @click="seeResults">
    <v-card-title class="font-weight-bold">
      {{ study.title }}
    </v-card-title>
    <v-card-subtitle>
      {{ study.canteen.name }}
      <!-- La recommandation dont l'activite est tiree : deux campagnes peuvent partager la meme,
           et le titre seul ne disait pas laquelle de leurs restitutions on ouvre. -->
      <span v-if="study.study && study.study.title" class="d-block recommendation">
        d'après « {{ study.study.title }} »
      </span>
    </v-card-subtitle>

    <v-card-text class="py-2">
      <p class="mb-1">
        <strong>Durée :</strong>
        {{ study.study.durationInDay }} jours
      </p>
      <p class="mb-1">
        <strong>Conditions :</strong>
        {{ study.study.conditions }}
      </p>
    </v-card-text>

    <v-spacer></v-spacer>

    <v-card-actions class="px-4 py-4" v-if="study.onGoing">
      <v-spacer></v-spacer>
      <v-btn color="warning" variant="tonal" class="rounded" disabled>
        Action en cours
      </v-btn>
    </v-card-actions>

    <v-spacer></v-spacer>

    <v-card-actions class="px-4 py-4">
      <v-spacer></v-spacer>
      <v-icon color="primary">$arrow-right-line</v-icon>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    study: {
      type: Object,
      required: true,
    },
  },
  methods: {
    // La carte menait au tableau de bord d'administration de `djf_surveys`, qui agregeait toutes
    // cantines et toutes campagnes confondues et n'etait ouvert qu'aux auteurs du referentiel :
    // le gestionnaire y recevait un 403. La restitution est desormais celle de son activite.
    seeResults() {
      this.$router.push({ name: "ActionResults", params: { id: this.study.id } })
    },
  },
}
</script>

<style scoped>
.recommendation {
  font-style: italic;
}
</style>
